import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { getFileExtensionFromReference } from './utils';
import { memo } from 'react';
import StyledUIFileAttachment from './StyledUIFileAttachment';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { FileTypeIcon } from 'file-manager-components/components/FileTypeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const renderName = (fileReference, portalId) => /*#__PURE__*/_jsx(TruncateString, {
  children: /*#__PURE__*/_jsx(Link, {
    external: true,
    href: `${getFullUrl('app')}/file-preview/${encodeURIComponent(portalId)}/file/${encodeURIComponent(fileReference.additionalProperties.fileId)}/`,
    children: fileReference.label
  })
});
const FileAttachment = ({
  fileReference
}) => {
  const portalId = PortalIdParser.get();
  if (!portalId) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledUIFileAttachment, {
    fileName: renderName(fileReference, portalId),
    size: "small",
    renderPreview: /*#__PURE__*/_jsx(FileTypeIcon, {
      fileType: fileReference.additionalProperties.type,
      extension: getFileExtensionFromReference(fileReference),
      size: "500"
    })
  });
};
export default /*#__PURE__*/memo(FileAttachment);